import { createMemoStyles } from '@mantine/core';

export default createMemoStyles({
  selectGroup: {},
  select: {},
  label: {},
});
